import { PlusIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getWorkspaceData } from "src/actions/workspace";
import Button from "src/components/Shared/Buttons/Button";
import PaginationFooter from "src/components/Shared/PaginationFooter";
import Search from "src/components/Shared/Search";
import TRHeader from "src/components/Shared/Table/TRHeader";
import Table from "src/components/Shared/Table/Table";
import TableOptions from "src/components/Shared/TableOptions";
import WorkspaceEntry from "src/components/Workspaces/WorkspaceEntry";
import WorkspacesAddModal from "src/components/Workspaces/WorkspacesModals/WorkspacesAddModal";
import useFetch from "src/hooks/useFetch";

const WorkspaceList = ({ user, viewOnly = false }) => {
  const navigate = useNavigate();

  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [keyword, setKeyword] = useState("");

  const [showAddModal, setShowAddModal] = useState(false);
  const [workspaceType, setWorkspaceType] = useState("");

  const {
    response: { data: workspaces, meta },
    status: { done: workspacesLoaded },
    refreshData: refreshWorkspaces,
  } = useFetch(`/workspaces/list`, { method: "post", query: {}, data: { includes: ["groups", "users", "pages"], limit: limit || 20, offset: offset || 0, keyword: keyword || "" } });

  useEffect(() => {
    refreshWorkspaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, offset, keyword]);

  const handlePaginationChange = ({ limit, offset }) => {
    setLimit(limit);
    setOffset(offset);
  };

  if (!user?._id) return <></>;

  if (user?.type === "editor" && user?.workspaces?.length === 1) {
    navigate(`/workspaces/${user.workspaces[0]._id}`);
    return <></>;
  }

  return (
    <>
      <TableOptions
        leftContent={
          <Search
            keyword={keyword}
            setKeyword={(val) => {
              setOffset(0);
              setKeyword(val);
            }}
          />
        }
        rightContent={
          workspacesLoaded &&
          user?.type === "admin" && (
            <Button
              version="secondary"
              hoverText="Add a workspace"
              onClick={() => {
                setWorkspaceType("IFRAME_EMBED");
                setShowAddModal(true);
              }}>
              <PlusIcon className="h-4 w-4 stroke-[3px]" /> Add workspace
            </Button>
          )
        }
      />
      <Table
        tableHeader={
          <TRHeader>
            <th
              scope="col"
              className="rounded-tl-lg py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
              Name
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              Pages
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Groups
            </th>
            <th
              scope="col"
              className="hidden rounded-tr-lg px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              Users
            </th>
            {/* <th
              scope="col"
              className="rounded-tr-lg relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span className="sr-only">Edit</span>
            </th> */}
          </TRHeader>
        }
        colSpan="5"
        loaded={workspacesLoaded}
        dataExists={workspaces?.length > 0}>
        {workspaces?.map((workspace) => (
          <WorkspaceEntry
            viewOnly={viewOnly}
            key={workspace._id}
            workspace={workspace}
          />
        ))}
      </Table>
      <PaginationFooter
        itemName="Workspace record"
        limit={limit}
        offset={offset}
        count={meta?.count}
        onChange={handlePaginationChange}
      />

      <WorkspacesAddModal
        isOpen={showAddModal}
        workspaceType={workspaceType}
        onCancel={() => setShowAddModal(false)}
        onSuccess={() => {
          setShowAddModal(false);
          refreshWorkspaces();
        }}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, { getWorkspaceData })(WorkspaceList);
